import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-medical-examination-grid',
  templateUrl: './medical-examination-grid.component.html',
  styleUrls: ['./medical-examination-grid.component.css']
})
export class MedicalExaminationGridComponent implements OnInit {
  title ="View Medical Examination";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/Medical Examination/medical-examination-grid/medical-examination-grid.component.ts